import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class MerchantContractQueryCriteriaClass extends BaseCriteriaModel {
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  merchant_guid?: Optional<string> = Optional.empty();
  comp_guid?: Optional<string> = Optional.empty();
  merchant_contract_key?: Optional<string> = Optional.empty();
  merchant_contract_code?: Optional<string> = Optional.empty();
  hdr?: Optional<string> = Optional.empty();
}

export class MerchantContractCriteriaModelQuery {
  query = '';

  constructor(contractCriteriaModel: MerchantContractQueryCriteriaClass) {
    console.log('merchantriteriaModel', contractCriteriaModel);

    if (!contractCriteriaModel) {
      return;
    }
    this.query += contractCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += contractCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += contractCriteriaModel.merchant_guid.filter(x => x !== '').map(x => '&merchant_guid=' + x).orElse('');
    this.query += contractCriteriaModel.merchant_contract_key.filter(x => x !== '').map(x => '&merchant_contract_key=' + x).orElse('');
    this.query += contractCriteriaModel.comp_guid.filter(x => x !== '').map(x => '&comp_guid=' + x).orElse('');
    this.query += contractCriteriaModel.merchant_contract_code.filter(x => x !== '').map(x => '&merchant_contract_code=' + x).orElse('');
    this.query += contractCriteriaModel.hdr.filter(x => x !== '').map(x => '&hdr=' + x).orElse('');

    this.query += '&status=' + contractCriteriaModel.status;
    this.query += '&orderBy=' + contractCriteriaModel.orderBy;
    this.query += '&order=' + contractCriteriaModel.order;
    this.query += '&offset=' + contractCriteriaModel.offset + '&limit=' + contractCriteriaModel.limit;
  }

}
